import { Component, OnInit } from '@angular/core';
import {Platform} from "@ionic/angular";

@Component({
  selector: 'app-record',
  templateUrl: './record.page.html',
  styleUrls: ['./record.page.scss'],
})
export class RecordPage implements OnInit {
  isWeb: boolean;

  constructor( private platform: Platform,) {

    this.isWeb = this.platform.width() >= 900;
    console.log(this.isWeb,this.platform.width())
  }

  ngOnInit() {
  }


}
